import React, { ReactNode } from 'react';
import { Dialog } from '@headlessui/react';
import { CloseBlackIcon } from 'assets/icons';

interface ICardMitModelProps {
  open: boolean;
  onClose: () => void;
  isDisabled?: boolean;
  config: {
    id?: string;
    buttonSection?: ReactNode;
    titleSection?: ReactNode;
    textSection?: ReactNode;
    onClose?: () => void;
  };
}

const CardMitModel = ({ open, onClose, config, isDisabled }: ICardMitModelProps) => {
  return (
    <Dialog as="div" className="relative z-10" open={open} onClose={() => {}}>
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white dark:bg-slate-800 p-6 text-left align-middle shadow-xl dark:shadow-slate-900/50 transition-all border border-gray-100 dark:border-slate-700">
            <div className="flex flex-1 flex-row justify-end">
              <CloseBlackIcon
                onClick={() => {
                  if (isDisabled) return;
                  onClose();
                }}
                className="w-[12px] cursor-pointer mb-2 dark:text-gray-400 dark:hover:text-gray-200"
              />
            </div>
            <Dialog.Title className="font-medium leading-6 text-gray-900 dark:text-white">
              {config?.titleSection}
            </Dialog.Title>
            {config?.textSection}
            {config?.buttonSection}
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};

export default CardMitModel;
